import { makeVar } from '@apollo/client/cache';
import { FortnoxStatus } from 'models/fortnox';
import { VismaStatus } from 'models/visma';

export const selectedClinicsVar = makeVar({} as { [key: string]: string });
export const invoiceDateVar = makeVar({ orderToDate: new Date(), invoiceDate: new Date() });
export const fortnoxStatusVar = makeVar<FortnoxStatus>({ enabled: false, authorized: false, clientId: '' });
export const vismaStatusVar = makeVar<VismaStatus>({ enabled: false, authorized: false, clientId: '' });
